export async function getNextModuleFromService(module) {
    let currentModule = {};
    let courses = sessionStorage.getItem('modules') !== undefined ? JSON.parse(sessionStorage.getItem('modules')).courses : [];
    for (let i = 0; i < courses.length; i++) {
        if (module.course_id === courses[i].course_id) {
            let allModules = courses[i].modules;
            for (let j = 0; j < allModules.length; j++) {
                if (parseInt(module.module_seq_no) + 1 === parseInt(allModules[j].module_seq_no)) {
                    currentModule = Object.assign(allModules[j]);
                    currentModule['course_id'] = courses[i].course_id;
                    currentModule['course_code'] = courses[i].course_code;
                    currentModule['course_name'] = courses[i].course_name;
                    currentModule['course_desc'] = courses[i].course_desc;
                    currentModule['color'] = courses[i].color;
                    sessionStorage.setItem("currentModule", JSON.stringify(currentModule));
                }
            }

        }
    }
    return currentModule;

};

export async function getPrevModuleFromService(module) {
    let courses = sessionStorage.getItem('modules') !== undefined ? JSON.parse(sessionStorage.getItem('modules')).courses : [];
    let currentModule = {}
    for (let i = 0; i < courses.length; i++) {
        if (module.course_id === courses[i].course_id) {
            let allModules = courses[i].modules;
            for (let j = 0; j < allModules.length; j++) {
                if (parseInt(module.module_seq_no) - 1 === parseInt(allModules[j].module_seq_no)) {
                    currentModule = Object.assign(allModules[j]);
                    currentModule['course_id'] = courses[i].course_id;
                    currentModule['course_code'] = courses[i].course_code;
                    currentModule['course_name'] = courses[i].course_name;
                    currentModule['course_desc'] = courses[i].course_desc;
                    currentModule['color'] = courses[i].color;
                    sessionStorage.setItem("currentModule", JSON.stringify(currentModule));
                }
            }
        }
    }
    return currentModule
};